module.exports = __webpack_public_path__ + "static/graph-year-5_fr-44dc694a26c8f52484984dcb847a9dde.svg";